export const TEST_ID = 'boundaryDetailsPage';

export const CARD_HEADER_DETAIL_TYPE = 'boundary';

export const DETAIL_TYPE_CLIENT = 'client';

export const DETAIL_TYPE_FARM = 'farm';

export const DETAIL_TYPE_FIELD = 'field';

export const DETAIL_TYPE_CITY = 'city';

export const DETAIL_TYPE_STATE = 'state';

export const DETAIL_TYPE_ZIP = 'zip';
